import { render, staticRenderFns } from "./fontsSettingsParagraph.vue?vue&type=template&id=4930c8a0&scoped=true&"
import script from "./fontsSettingsParagraph.vue?vue&type=script&lang=js&"
export * from "./fontsSettingsParagraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4930c8a0",
  null
  
)

export default component.exports